export default "__VITE_ASSET__DHymAXfl__"